function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP CTA component for home page
 * 
 */
import * as React from 'react';
import './Contact.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      title,
      address1,
      address2,
      phone,
      email
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "Contact",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inner",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "content",
          children: [/*#__PURE__*/_jsx("div", {
            className: "title",
            children: title
          }), /*#__PURE__*/_jsx("div", {
            className: "",
            children: address1
          }), /*#__PURE__*/_jsx("div", {
            className: "",
            children: address2
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "content",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: faPhone,
              className: "left"
            }), /*#__PURE__*/_jsx("a", {
              href: 'tel:' + phone,
              children: phone
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: faEnvelope,
              className: "left"
            }), /*#__PURE__*/_jsx("a", {
              href: 'mailto:' + email,
              children: email
            })]
          })]
        })]
      })
    });
  }
}
_defineProperty(Contact, "defaultProps", {
  title: 'Succinct title',
  address1: '<p>This is some HTML content</p>',
  address2: '<p>This is some HTML content</p>',
  phone: '<p>This is some HTML content</p>',
  email: '<p>This is some HTML content</p>'
});
export default Contact;